import React, { Component } from "react";
import { compose } from "react-apollo";
import Table from "components/Table/Table";
import { withQuery } from "containers/withQuery";
import PencilButton from "components/ActionButtons/PencilButton";
import { LOCATIONS_QUERY } from "../generalRegisterQueries";
import LocationEdit from "./LocationEdit";

const headers = [
  {
    label: "Id", key: "id",
  },
  {
    label: "Local", key: "name",
  },
  {
    label: "Código", key: "code",
  },
  {
    label: "Capacidade", key: "capacity",
  },
  {
    label: "Sensor (dosagem)", key: "sensor",
  },
  {
    label: "Sensor de nível", key: "monitorSensor",
  },
  {
    label: "", key: "action",
  },
];

// capacity vem do scalar :decimal, ou seja, string.
const formatCapacity = (capacity) => {
  const parsed = parseFloat(capacity);
  return Number.isFinite(parsed) ? parsed.toLocaleString("pt-BR") : "-";
};

class LocationsTable extends Component {
  state = {
    currentEditId: null,
  }

  onFinishEdit = () => this.setState({ currentEditId: null });

  render() {
    const { currentEditId } = this.state;
    return (
      <React.Fragment>
        <Table
          headers={headers}
          matchHeaders
          items={[...this.props.inventoryLocations]
            .sort((a, b) => a.id - b.id)
            .map(location => ({
              ...location,
              capacity: formatCapacity(location.capacity),
              sensor: location.sensor ? location.sensor.name : "-",
              monitorSensor: location.monitorSensor ? location.monitorSensor.name : "-",
              action: (
                <PencilButton
                  onPencilEditClick={() => this.setState({
                    currentEditId: location.id
                  })}
                />
              )
            }))
          }
        />
        {currentEditId !== null && (
          <LocationEdit id={currentEditId} onFinishEdit={this.onFinishEdit} />
        )}
      </React.Fragment>
    );
  }
}

export default compose(
  withQuery({ query: LOCATIONS_QUERY }),
)(LocationsTable);
